import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';

@Injectable()
export class FacilitiesParkingService {

    private _Settings: any;

    public get Settings(): any {
        return this._Settings;
    }


    constructor(
        private http: HttpClient,
        private logger: LoggerService
    ) {
        this.log('constructor', null, LogCategory.Constructor);
    }


    ParkingEditableFieldList: any = {
        choice: '',
        startDate: true,
        startTime: true,
        startTimeData: true,
        endDate: true,
        endTime: true,
        endTimeData: true,
        numberOfPermits: 0,
        reason: true
    };

    private fetchSettings() {
        return this.http.get<any>(environment.apiUrl + '/facilities/parkingSettings');
    }

    public fetchSettingsAndValidate(parkingForm, permitsArray) {
        if (this._Settings) {
            parkingForm.timeList = this._Settings.ParkingTimes.split(',');
            this.validateParkingData(parkingForm, permitsArray);
        } else {
            this.fetchSettings().subscribe(
                (settings) => {
                    this._Settings = settings;
                    parkingForm.timeList = settings.ParkingTimes.split(',');
                    this.validateParkingData(parkingForm, permitsArray);
                }
            )
        }

    }

    initializeFormValidationProperities(parkingForm) {
        parkingForm.errors = {};
        parkingForm.warnings = {};
        parkingForm.touched = {};
        parkingForm.editables = this.ParkingEditableFieldList;
    }

    validateParkingData(parkingForm, permitArray) {
        parkingForm.errors = {};
        parkingForm.nameErrors = {};
        parkingForm.emailErrors = {};
        parkingForm.warnings = {};
        parkingForm.editables = this.ParkingEditableFieldList;

        if (parkingForm.choice == null || parkingForm.choice == '')
            parkingForm.errors['choice'] = 'Please choose a distribution preference.'

        if (parkingForm.startDate == null || parkingForm.startDate == '')
            parkingForm.errors['startDate'] = 'Start Date is required.';

        if (parkingForm.startTimeData == null || parkingForm.startTimeData == '')
            parkingForm.errors['startTime'] = 'Start Time is required.';

        if (parkingForm.endDate == null || parkingForm.endDate == '')
            parkingForm.errors['endDate'] = 'End Date is required.'

        if (parkingForm.endTimeData == null || parkingForm.endTimeData == '')
            parkingForm.errors['endTime'] = 'End Time is required.'

        if ((parkingForm.startDate != '') && (parkingForm.endDate != '')) {
            var startDate = new Date(parkingForm.startDate + ' ' + parkingForm.startTimeData);
            var endDate = new Date(parkingForm.endDate + ' ' + parkingForm.endTimeData);

            if (startDate >= endDate)
                parkingForm.errors['endTimeData'] = 'End Date and Time must be later than Start Date and Time';
            else {
                parkingForm.startTime = startDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
                parkingForm.endTime = endDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
            }
        }

        if (parkingForm.choice == 'requester') {
            permitArray.length = 0;
            permitArray.push({ Name: "", Email: "" });
            parkingForm.nameErrors = {};
            parkingForm.emailErrors = {};
            if (!parkingForm.numberOfPermits) {
                parkingForm.errors['numberOfPermits'] = 'The number of parking passes is required.';
            }
            if (!parkingForm.reason)
                parkingForm.errors['reason'] = 'Please provide the guest or event name and any applicable details is required.';

        }
        else if (parkingForm.choice == 'facilities') {
            parkingForm.numberOfPermits = '';

            for (var i = 0; i < permitArray.length; i++) {
                if (permitArray[i].Name == '') {
                    parkingForm.errors['name'] = 'A name is missing above.';
                    parkingForm.nameErrors['name' + i] = 'Name is required.';
                }
            }

            for (var i = 0; i < permitArray.length; i++) {

                var email = permitArray[i].Email;
                if (email == '') {
                    parkingForm.emailErrors['email' + i] = 'Email is required.';
                    parkingForm.errors['email'] = 'An email address is missing above.';
                }
                else if (!this.validateEmail(email))
                    parkingForm.emailErrors['badEmail' + i] = 'Please enter a valid email address.';
            }
        }

        return parkingForm;
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.FacilitiesParking, category);
    }

    private validateEmail(email) {
        var re = /^([\S]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
        return re.test(email);
    }

    public postParkingRequest(facilitiesParking): Observable<string> {
        const url = `${environment.apiUrl}/facilities/parking`;
        var subject = new Subject<string>();

        this.log("postParking", url);
        this.http.post<any>(url, facilitiesParking)
            .subscribe(
                () => subject.next('complete'),
                error => subject.next('error'),
            );

        return subject.asObservable();
    }
}
